<template>
  <div v-if="showSync" class="sync">
    <div v-if="!isSuccess" class="process-bar">
      <el-progress :percentage="percentage"></el-progress>
    </div>
    <div v-if="!isSuccess" class="process-desc">
      <el-timeline>
        <el-timeline-item
          v-for="(activity, index) in activities"
          :key="index"
          :icon="activity.icon"
          :type="activity.type"
          :color="activity.color"
          :size="activity.size"
          :timestamp="activity.timestamp"
        >
          {{ activity.content }}
        </el-timeline-item>
      </el-timeline>
    </div>
    <!-- 完成 -->
    <div v-if="isSuccess">
      <el-result
        icon="success"
        title="成功提示"
        subTitle="您已经完成所有初始化设置！"
      >
        <template slot="extra">
          <el-button type="primary" size="medium" @click="handleSyncDone">{{
            btnName
          }}</el-button>
        </template>
      </el-result>
    </div>
  </div>
</template>

<script>
import DateUtils from "@/utils/datetime";
export default {
  data() {
    return {
      showSync: false,
      percentage: 0,
      activities: [],
      isSuccess: false
    };
  },
  props: {
    btnName: {
      type: String,
      default: "确定"
    },
    startDirectly: {
      //初始系统时为true，系统手工同步为false;
      type: Boolean,
      default: false
    }
  },
  methods: {
    initActivities: function() {
      for (let index = 0; index < 4; index++) {
        this.resetActivities(index, "new");
      }
    },
    oneKeySync: function(data) {
      if (this.startDirectly) {
        this.showSync = true;
        this.checkStatus();
      } else {
        this.$confirm(
          "将启动淘宝店铺信息同步，该过程消耗时间比较久，具体时间取决于宝贝数量, 是否继续?",
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          }
        )
          .then(() => {
            this.showSync = true;
            this.checkStatus();
          })
          .catch(() => {
            this.showSync = false;
            this.$message({
              type: "info",
              message: "已取消删除"
            });
          });
      }
    },
    //第一步，检测状态
    checkStatus: function(data) {
      this.percentage = 5; //5%
      this.resetActivities(0, "doing");
      //同步前检测状态，比如是否宝贝数量超过5000
      this.$api.sync
        .checkStatus()
        .then(res => {
          //操作成功
          if (res.code == 200) {
            this.resetActivities(0, "done");
            this.percentage = 8;
            this.syncShop();
          } else {
            this.resetActivities(0, "error");
            this.$message({
              message:
                "操作失败, [ code: " +
                res.code +
                "， message: " +
                res.msg +
                " ]",
              type: "error"
            });
          }
        })
        .then(data != null ? data.callback : "");
    },
    //第二步，同步店铺信息
    syncShop: function(data) {
      this.percentage = 10;
      this.resetActivities(1, "doing");

      //获取数据
      this.$api.sync
        .syncShop()
        .then(res => {
          //操作成功
          if (res.code == 200) {
            this.percentage = 18;
            this.resetActivities(1, "done");

            this.syncCat();
          } else {
            this.resetActivities(1, "error");
            this.$message({
              message:
                "操作失败, [ code: " +
                res.code +
                "， message: " +
                res.msg +
                " ]",
              type: "error"
            });
          }
        })
        .then(data != null ? data.callback : "");
    },
    //第三步，同步店铺类目
    syncCat: function(data) {
      this.percentage = 20;
      this.resetActivities(2, "doing");
      //获取数据
      this.$api.sync
        .syncCat()
        .then(res => {
          //操作成功
          if (res.code == 200) {
            this.percentage = 38;
            this.resetActivities(2, "done");
            this.syncItem();
          } else {
            this.resetActivities(2, "error");
            this.$message({
              message:
                "操作失败, [ code: " +
                res.code +
                "， message: " +
                res.msg +
                " ]",
              type: "error"
            });
          }
        })
        .then(data != null ? data.callback : "");
    },
    //第四步，同步商品
    syncItem: function(data) {
      //默认启动55%
      this.percentage = 55;
      this.resetActivities(3, "doing");

      //每10s轮询一次；
      this.timer = window.setInterval(() => {
        setTimeout(() => {
          this.checkItemSyncStatus();
        }, 0);
      }, 10000);

      //如果是手工同步
      if (!this.startDirectly) {
        //从数据库中同步商品(需删除表)
        this.$api.sync
          .syncItem()
          .then(res => {
            //操作成功
            if (res.code == 200) {
              this.resetActivities(3, "done");
              this.percentage = 100;
              this.isSuccess = true;
              this.$message({ message: "操作成功", type: "success" });
              //销毁Timer
              window.clearInterval(this.timer);
              //完成同步
              this.handleSyncDone();
            } else {
              //销毁Timer
              window.clearInterval(this.timer);

              this.resetActivities(3, "error");
              this.$message({
                message:
                  "操作失败, [ code: " +
                  res.code +
                  "， message: " +
                  res.msg +
                  " ]",
                type: "error"
              });
            }
          })
          .then(data != null ? data.callback : "");
      }
    },
    checkItemSyncStatus: function(data) {
      this.$api.sync
        .checkItemSyncStatus()
        .then(res => {
          //操作成功
          if (res.code == 200) {
            //后台传来的同步进度（0.0 - 1）
            var curPercent = parseFloat(res.data);
            if (curPercent > 0.9) {
              this.resetActivities(3, "done");
              this.percentage = 100;
              this.isSuccess = true;
              this.$message({ message: "操作成功", type: "success" });
              //销毁Timer
              window.clearInterval(this.timer);
              //完成同步
              this.handleSyncDone();
            } else {
              this.percentage = 55 + Math.ceil(45 * curPercent);
            }
          } else {
            this.resetActivities(3, "error");
            this.$message({
              message:
                "操作失败, [ code: " +
                res.code +
                "， message: " +
                res.msg +
                " ]",
              type: "error"
            });
            //销毁Timer
            window.clearInterval(this.timer);
          }
        })
        .then(data != null ? data.callback : "");
    },
    handleSyncDone: function() {
      this.$emit("handleSyncDone");
    },
    //重新设置步骤的内容；status: new , doing, done, error
    resetActivities: function(index, status) {
      let activityName = [
        "从淘宝获取店铺信息",
        "同步店铺信息",
        "同步商家店内类目",
        "同步宝贝（耗时长）"
      ];

      let statusDesc = null;
      let type = null;
      let icon = null;
      let timestamp = "无";
      if ("new" == status) {
        statusDesc = "未开始";
      } else if ("doing" == status) {
        statusDesc = "进行中";
        type = "primary";
        icon = "el-icon-loading";
      } else if ("done" == status) {
        statusDesc = "已完成";
        type = "success";
        icon = "el-icon-check";
        timestamp = DateUtils.format(new Date());
      } else if ("error" == status) {
        statusDesc = "执行错误";
        type = "danger";
        icon = "el-icon-close";
        timestamp = DateUtils.format(new Date());
      }

      this.activities[index] = {
        content: activityName[index] + " - " + statusDesc,
        size: "large",
        timestamp: timestamp,
        type: type,
        icon: icon
      };
      this.$forceUpdate(); //因为VUE不会检测数组对象的变化；
    }
  },
  created: function() {
    if (this.startDirectly) {
      this.showSync = true;
    }
    this.initActivities();
  },
  destroyed() {
    window.clearInterval(this.timer);
  }
};
</script>

<style lang="scss" scoped>
.sync {
  padding: 0 40;
  margin: 0 80;
  text-align: left;
  .process-bar {
    padding-bottom: 40px;
  }
  .process-desc {
    text-align: left;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/User/SysSync.vue